module.exports = __webpack_public_path__ + "img/img_guige.06311897.png";